import "./Collapse.css";

import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { cn } from "@/lib/utils";

/** Animates a panel while keeping closed content inert and out of the tab order. */
export function Collapse({
  open,
  className,
  children,
  ...rest
}: { open: boolean; className?: string; children: ReactNode } & Omit<ComponentPropsWithoutRef<"div">, "className" | "children" | "style">) {
  return (
    <div {...rest} inert={!open} className={cn("collapse-panel grid transition-all duration-300 motion-reduce:transition-none", className)}>
      <div className="overflow-hidden">{children}</div>
    </div>
  );
}
